import { render, staticRenderFns } from "./hzqy.vue?vue&type=template&id=55cf7534&scoped=true&"
import script from "./hzqy.vue?vue&type=script&lang=js&"
export * from "./hzqy.vue?vue&type=script&lang=js&"
import style0 from "./hzqy.vue?vue&type=style&index=0&id=55cf7534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf7534",
  null
  
)

export default component.exports